

import Vue from "vue";

import CSV from "@/components/templates/CSV.vue";
import CopyButton from "@/components/templates/CopyButton.vue";
import Top from "@/components/templates/Top.vue";

import { mapActions, mapGetters } from "vuex";

import i18n from "@/plugins/i18n";
import * as views from "@/plugins/utils/View";
import * as crud from "@/plugins/utils/Crud";
import * as action from "@/store/actions";
import { Corp, Follow, Server, View } from "@/types/conf";
import store from "@/store/index";
import FollowDetail from "./FollowDetail.vue";

export default Vue.extend({
  name: "",
  props: ["extenFeat"],
  data: () => ({
    canDelete: false,
    canCreate: false,
    canUpdate: false,
    alertType: "",
    alertMessage: "",
    followList: [] as Follow[],
    corpList: [] as Corp[],
    serverList: [] as Server[],
    selectedItem: null as Follow | null,
    search: "",
    dialog: false,
    dialogDelete: false,
    loadingList: false,
  }),
  computed: {
    ...mapGetters({
      views: "auth/views",
      hoverColor: "lookAndFeel/hoverColor",
      menuIconColor: "lookAndFeel/menuIconColor",
      menuFontColor: "lookAndFeel/menuFontColor",
    }),
    computedItems(): Follow[] {
      const arr = this.followList.filter(
        (item) => item.entityId === this.extenFeat.id
      );
      return arr;
    },
  },
  async mounted() {
    this.loadingList = true;
    this.followList = await this.getFollowList(action.FOLLOW_CONTROLLER);
    this.actionHandler();
    this.loadingList = false;
  },

  components: {
    CSV,
    CopyButton,
    Top,
    FollowDetail
},

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch("lookAndFeel/setCorpName");
    const corpName = store.state.lookAndFeel.corpName as string;
    if (!!to.params.extenFeat) {
      next();
    } else {
      next({
        name: "extension",
        params: { corp: corpName, lang: navigator.language.slice(0, 2) },
      });
    }
  },
  methods: {
    ...mapActions({
      getFollowList: "crudService/getList",
      deleteFollow: "crudService/deleteObject",
    }),

    headers() {
      return [
        {
          text: i18n.t("misc.actions"),
          value: "actions",
          sortable: false,
        },
        {
          text: i18n.t("misc.order"),
          value: "order",
        },
        {
          text: i18n.t("misc.num"),
          value: "number"
        },
        {
          text: i18n.t("misc.timeout"),
          value: "timeout",
        },
      ];
    },

    actionHandler() {
      const view = this.views.find((v: View) => v.name == views.EXTENSION); //view name
      if (view) {
        this.canDelete = view.actions.includes(crud.DELETE);
        this.canCreate = view.actions.includes(crud.CREATE);
      }
    },
    editItem(item: Follow) {
      this.navigateTo(item);
    },

    deleteItem(item: Follow) {
      this.selectedItem = item;
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      const response = await this.deleteFollow({
        action: action.FOLLOW_CONTROLLER,
        id: this.selectedItem?.id,
      });
      this.closeDelete();
      if (response) {
        this.alertType = "green darken-1";
        this.alertMessage = ((i18n.t("misc.deleted") as string) +
          i18n.t("misc.defaultSuccess")) as string;
        let itemListUpdated = [...this.followList];
        this.followList = itemListUpdated.filter(
          (trunk) => trunk.id != this.selectedItem?.id
        );
      } else {
        this.alertType = "error";
        this.alertMessage = i18n.t("misc.defaultError") as string;
      }
      this.$store.dispatch("snackbar/showSnack", {
        message: this.alertMessage,
        color: this.alertType,
        timeout: 3000,
      });
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    navigateTo(follow: any = false) {
      if (follow === "back") {
        this.$router.replace({
          name: "extension",
        });
      } else if (follow) {
        this.$router.replace({
          name: "follow/update",
          params: { followToUpdate: follow, exten: this.extenFeat },
        });
      } else {
        this.$router.replace({
          name: "follow/new",
          params: { exten: this.extenFeat },
        });
      }
    },

    async refreshList() {
      this.loadingList = true;
      this.followList = await this.getFollowList(action.FOLLOW_CONTROLLER);
      this.actionHandler();
      this.loadingList = false;
    },
  },
});
